import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { getPoppularHotels } from './actions'


import {GridList, GridTile} from 'material-ui/GridList';
import {CardTitle} from 'material-ui/Card';
import IconButton from 'material-ui/IconButton';
import Subheader from 'material-ui/Subheader';
import StarBorder from 'material-ui/svg-icons/toggle/star-border';
import Paper from 'material-ui/Paper';
import SessionHeader from '../../components/SessionHeader/SessionHeader'
import ButtonFavorite from '../../components/ButtonFavorite'
import {
  addBookmark,
  deleteBookmark
} from '../Bookmark/actions'
import language from '../../config/language'

const styles = {
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    paddingBottom: 5
  },
  gridList: {
    width: '100%',
    overflowY: 'auto',
  },
};

 export class HotelsPopularContainer extends Component {
  static defaultProps = {
    getPoppularHotels: () => {},
    limit: 4,
    hiddenSeemore: false
   }
  componentDidMount() {
    this.props.getPoppularHotels()
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.props.lang) {
      this.props.getPoppularHotels()
    }
  }
  renderContent() {
    if (this.props.error) {
      return <p>{language[this.props.lang].system.incorrect}</p>
    }
    if (this.props.popular.length) {
      return (
        <div style={styles.root}>
        <GridList
            cellHeight={115}
            style={styles.gridList}
            padding={10}
            cols={2}
          >
            {this.props.popular.slice(0, this.props.limit).map((tile) => (
              <GridTile
                style={{ padding: 0, borderRadius: 3 }}
                titleBackground="linear-gradient(to top, rgba(0,0,0,0.7) 0%,rgba(0,0,0,0.3) 70%,rgba(0,0,0,0) 100%)"
                // titleBackground="linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(255, 255, 255, 0)"
                containerElement={<Link to={'/details/popularHotels/'+tile.id} />}
                key={tile.img}
                title={<b>{tile.title}</b>}
                titleStyle={{ fontSize: 17 }}
                subtitle={(this.props.areas.find(value => value.id === tile.area_id) || { title_th: '', title_en: '' })['title_'+this.props.lang]}
                actionIcon={
                  <ButtonFavorite
                    onClick={(event) => {
                      event.preventDefault()
                      this.props.bookmark.some(value => value.contentType === 'popularHotels' && value.contentId === tile.id)
                      ? this.props.deleteBookmark(this.props.bookmark.find(value => value.contentId === tile.id && value.contentType === 'popularHotels').id || '')
                      : this.props.addBookmark({
                          contentType: 'popularHotels',
                          contentId: tile.id
                        })
                    }}
                    isFollow={this.props.bookmark.some(value => value.contentType === 'popularHotels' && value.contentId === tile.id)}
                  />
                }
              >
                <img src={tile.cover_photo} />
              </GridTile>
            ))}
          </GridList>
        </div>
      )
    }
  }
  render() {
    const {
      title,
      seemore,
      loading,
    } = language[this.props.lang].hotels.popular
    return (
      <Paper zDepth={1} style={{ padding: 5, marginTop: 10 }}>
        <SessionHeader
          title={title}
          titleColor='#009688'
          textSeemore={seemore}
          lineSeemore={'/home/hotels'}
          hiddenSeemore={this.props.hiddenSeemore}
        />
        {
          this.props.loading
          ? <p>{loading}</p>
          : this.renderContent()
        }
      </Paper>
    )
  }
}

const mapStateToProps = ({ lang, category, bookmark, areas, ...state }) => ({
  popular: state.hotels.popular[lang].data,
  loading: state.hotels.popular.loading,
  lang,
  category,
  bookmark,
  areas
})
export default connect(mapStateToProps, {
  getPoppularHotels,
  addBookmark,
  deleteBookmark
})(HotelsPopularContainer)




// WEBPACK FOOTER //
// ./src/containers/Hotels/HotelsPopularContainer.js